<template>
    <div class="container">
        <h1>Event dispatcher</h1>

        <div>
            <button class="btn btn-success" v-on:click="onCaseStart">onCaseStart</button>
            <button class="btn btn-success ml-3" v-on:click="onCaseEnd">onCaseEnd</button>
        </div>

        <div>
            <button class="btn btn-success" v-on:click="onSinglePlayerCaseStart">onSinglePlayerCaseStart</button>
            <button class="btn btn-success ml-3" v-on:click="onSinglePlayerCaseEnd">onSinglePlayerCaseEnd</button>
        </div>
    </div>
</template>
<script>
    import {eventActions, eventCategories, postEventData} from "@/utils/AnalyticsUtil";

    export default {
        name: 'event-dispatcher',
        mounted() {

        },
        computed: {
            eventCase() {
                return {
                    "id": 666,
                    "themeId": 666,
                    "title": "[DEV TEST] Bennys chef",
                    "picture": "emoji-coins-240x240.png",
                    "type": "singlePlayer",
                    "pages": []
                }
            }
        },
        methods: {
            onCaseStart() {
                postEventData(eventCategories.multiPlayer, eventActions.caseStart, this.eventCase);
            },
            onCaseEnd() {
                postEventData(eventCategories.multiPlayer, eventActions.caseEnd, this.eventCase);
            },
            onSinglePlayerCaseStart() {
                postEventData(eventCategories.singlePlayer, eventActions.caseStart, this.eventCase);
            },
            onSinglePlayerCaseEnd() {
                postEventData(eventCategories.singlePlayer, eventActions.caseEnd, this.eventCase);
            }
        }
    }
</script>